export const changeImageSrc = (imageObject, newSrc) => {
  return new Promise((resolve) => {
    imageObject.setSrc(
      newSrc,
      () => {
        resolve();
      },
      { crossOrigin: 'anonymous' }
    );
    imageObject.src = newSrc;
    imageObject.eraser = undefined;
    imageObject.filters = [];
    imageObject.opacity = 1;
    imageObject.flipX = false;
    imageObject.flipY = false;
  });
};
